export const removeFilenameFromUrl = url => {
	return url.replace(/\/[^/]*$/, '');
};
